// Module
var code = "<div class=\"ui-grid-cell-contents u-flexEnd\">\n    <div class=\"u-flex u-flexMiddle c-dataType-number\" ng-class=\"{'is-negative-charge' : row.entity.amount < 0 && row.entity.payment && row.entity.payment !== '-'}\" ng-bind=\"row.entity.payment | invEmpty\"></div>\n</div>\n";
// Exports
module.exports = code;